import React from "react";
import ReqBox from "./ReqBox";

const statusMap = {
  completed: {
    card: "marketing_level_card_completed",
    badge: "marketing_level_bg_green",
    text: "Completed",
    icon: "bi-check-circle-fill",
    num: "marketing_level_bg_gray",
  },
  current: {
    card: "marketing_level_card_current shadow",
    badge: "bg-primary text-white",
    text: "Current Standing",
    icon: "bi-person-fill",
    num: "marketing_level_bg_blue",
  },
  next: {
    card: "marketing_level_card_next",
    badge: "marketing_level_bg_gold",
    text: "Next Target",
    icon: "bi-trophy-fill",
    num: "marketing_level_bg_gold",
  },
  locked: {
    card: "marketing_level_card_locked",
    badge: "marketing_level_bg_gray",
    text: "Locked",
    icon: "bi-lock-fill",
    num: "marketing_level_bg_gray",
  },
};

export default function TierCard({ t }) {
  const s = statusMap[t.status] || statusMap.locked;
  const reqBg =
    t.status === "completed"
      ? "marketing_level_req_green"
      : t.status === "current"
      ? "marketing_level_req_gold"
      : t.status === "next"
      ? "marketing_level_req_gold"
      : "marketing_level_req";

  return (
    <div className="marketing_level_min0">
      <div className={`card h-100 border-2 rounded-4 position-relative ${s.card}`}>
        {t.status === "current" && (
          <span
            className="badge bg-primary position-absolute top-0 start-50 translate-middle shadow-sm"
            style={{ fontSize: 10, zIndex: 2 }}
          >
            ★ YOU ARE HERE
          </span>
        )}
        {t.status === "next" && (
          <span
            className="badge marketing_level_bg_gold position-absolute top-0 end-0 translate-middle-y me-3 shadow-sm"
            style={{ fontSize: 10, zIndex: 2 }}
          >
            NEXT TARGET
          </span>
        )}

        <div className="card-body">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div className="d-flex gap-2 align-items-center">
              <span
                className={`rounded-2 fw-bold d-inline-flex align-items-center justify-content-center ${s.num}`}
                style={{ width: 32, height: 32 }}
              >
                {String(t.id).padStart(2, "0")}
              </span>
              <div>
                <div className="fw-bold lh-sm">
                  Tier {t.id}:<br />
                  {t.name}
                </div>
                <div className="small marketing_level_text_gold">
                  <i className="bi bi-star-fill me-1" />
                  {t.star} Star Milestone
                </div>
              </div>
            </div>
            <span className={`badge rounded-pill ${s.badge}`}>
              <i className={`bi ${s.icon} me-1`} />
              {s.text}
            </span>
          </div>

          <div className="small fw-bold text-uppercase marketing_level_text_blue mb-2">
            <i className="bi bi-list-check me-1" />
            Requirement to get there:
          </div>
          <div className={`rounded-3 p-2 mb-3 ${reqBg}`}>
            {t.verify && (
              <div className="small marketing_level_text_green fw-semibold mb-2">
                <i className="bi bi-shield-check me-1" />
                {t.verify}
              </div>
            )}
            <div className="row g-2">
              <ReqBox
                label="Total Clients"
                value={`${t.clients} Clients`}
                sub={t.subs?.[0]}
              />
              <ReqBox
                label="Total Connect"
                value={t.connect}
                sub={t.subs?.[1]}
              />
              <ReqBox
                label="Rating"
                value={`${t.rating} ★`}
                sub={t.subs?.[2]}
              />
            </div>
            <div className="small mt-2">
              <span className="marketing_level_text_muted">Prerequisite:</span>{" "}
              <strong>{t.prereq}</strong>
            </div>
          </div>

          <div className="small fw-bold text-uppercase marketing_level_text_blue mb-2">
            <i className="bi bi-gift me-1" />
            Benefits &amp; Privileges:
          </div>
          <div className="small mb-2">
            <span className="marketing_level_text_muted">Commission Rate:</span>{" "}
            <strong className="marketing_level_text_blue">{t.commission}</strong>
          </div>
          {(t.benefits || []).map((b, i) => (
            <div key={i} className="small d-flex gap-2 mb-1">
              <i className="bi bi-check2-circle marketing_level_text_green" />
              <span>{b}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

